/**
 * Admin Portal Routes
 * ============================================================================
 *
 * All /admin/* routes use LAYOUT_TYPES.ADMIN which mounts AdminLayout.
 * AdminLayout contains the role guard — no separate ProtectedRoute needed.
 * ============================================================================
 */

import { LAYOUT_TYPES, ROUTE_PATHS } from 'navigation/constants';
import type { RouteGroup } from 'navigation/types';
import { lazy } from 'react';

const AdminDashboard = lazy(() => import('@/features/admin/dashboard/view/admin-dashboard-page'));
const AdminSettingsPage = lazy(() => import('@/features/admin/settings/view/admin-settings-page'));
const AdminHelpPage = lazy(() => import('@/features/admin/help/view/admin-help-page'));
const AdminBusinesses = lazy(() => import('@/features/admin/businesses/view/admin-businesses-page'));
const AdminBusinessDetail = lazy(() => import('@/features/admin/businesses/view/admin-business-detail-page'));
const AdminSupport = lazy(() => import('@/features/admin/support/view/admin-support-page'));
const AdminSupportDetail = lazy(() => import('@/features/admin/support/view/admin-support-detail-page'));
const AdminRegulatory = lazy(() => import('@/features/admin/regulatory/view/admin-regulatory-page'));
const AdminRegulatoryDetail = lazy(() => import('@/features/admin/regulatory/view/admin-regulatory-detail-page'));
const AdminNotifications = lazy(() => import('@/features/admin/notifications/view/admin-notifications-page'));
const AdminNotificationDetail = lazy(() => import('@/features/admin/notifications/view/admin-notification-detail-page'));
const AdminAnalytics = lazy(() => import('@/features/admin/analytics/view/admin-analytics-page'));
const AdminTransactions = lazy(() => import('@/features/admin/transactions/view/admin-transactions-page'));
const AdminTransactionDetail = lazy(() => import('@/features/admin/transactions/view/admin-transaction-detail-page'));
const AdminInvoices = lazy(() => import('@/features/admin/invoices/view/admin-invoices-page'));
const AdminInvoiceDetail = lazy(() => import('@/features/admin/invoices/view/admin-invoice-detail-page'));
const AdminPayments = lazy(() => import('@/features/admin/payments/view/admin-payments-page'));
const AdminPaymentDetail = lazy(() => import('@/features/admin/payments/view/admin-payment-detail-page'));
const AdminAuditLog = lazy(() => import('@/features/admin/audit-log/view/admin-audit-log-page'));
const AdminTeam = lazy(() => import('@/features/admin/team/view/admin-team-page'));
const AdminTeamMemberDetail = lazy(() => import('@/features/admin/team/view/admin-team-member-detail-page'));
const AdminConfig = lazy(() => import('@/features/admin/config/view/admin-config-page'));

export const adminRoutes: RouteGroup = {
  name: 'admin',
  layout: LAYOUT_TYPES.ADMIN,
  routes: [
    { path: ROUTE_PATHS.ADMIN_DASHBOARD,        component: AdminDashboard },
    { path: ROUTE_PATHS.ADMIN_BUSINESSES,       component: AdminBusinesses },
    { path: ROUTE_PATHS.ADMIN_BUSINESS_DETAIL,  component: AdminBusinessDetail },
    { path: ROUTE_PATHS.ADMIN_SUPPORT,        component: AdminSupport },
    { path: ROUTE_PATHS.ADMIN_SUPPORT_DETAIL, component: AdminSupportDetail },
    { path: ROUTE_PATHS.ADMIN_REGULATORY,        component: AdminRegulatory },
    { path: ROUTE_PATHS.ADMIN_REGULATORY_DETAIL, component: AdminRegulatoryDetail },
    { path: ROUTE_PATHS.ADMIN_NOTIFICATIONS,       component: AdminNotifications },
    { path: ROUTE_PATHS.ADMIN_NOTIFICATION_DETAIL, component: AdminNotificationDetail },
    { path: ROUTE_PATHS.ADMIN_ANALYTICS,           component: AdminAnalytics },
    { path: ROUTE_PATHS.ADMIN_TRANSACTIONS,       component: AdminTransactions },
    { path: ROUTE_PATHS.ADMIN_TRANSACTION_DETAIL, component: AdminTransactionDetail },
    { path: ROUTE_PATHS.ADMIN_INVOICES,       component: AdminInvoices },
    { path: ROUTE_PATHS.ADMIN_INVOICE_DETAIL, component: AdminInvoiceDetail },
    { path: ROUTE_PATHS.ADMIN_PAYMENTS,       component: AdminPayments },
    { path: ROUTE_PATHS.ADMIN_PAYMENT_DETAIL, component: AdminPaymentDetail },
    { path: ROUTE_PATHS.ADMIN_TEAM,                component: AdminTeam },
    { path: ROUTE_PATHS.ADMIN_TEAM_MEMBER_DETAIL,  component: AdminTeamMemberDetail },
    { path: ROUTE_PATHS.ADMIN_AUDIT_LOG,     component: AdminAuditLog },
    { path: ROUTE_PATHS.ADMIN_CONFIG,        component: AdminConfig },
    { path: ROUTE_PATHS.ADMIN_SETTINGS,      component: AdminSettingsPage },
    { path: ROUTE_PATHS.ADMIN_HELP,          component: AdminHelpPage },
  ],
};
